import React from "react"; 
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import FacturaTemplate from '../views/module/facturacion/FacturaTemplate';

// Styled dialog component
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

// Centered container for the content
const CenteredContent = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  height: '100%',
});

export default function FormModalInvoice (props) {
  return (
    <>
      <BootstrapDialog
        onClose={props.handleCloseModal}
        aria-labelledby="customized-dialog-title"
        open={props.isOpen}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle id="customized-dialog-title">
          {props.header}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={props.handleCloseModal}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <CenteredContent>
            <FacturaTemplate formData={props.formData} />
          </CenteredContent>
        </DialogContent>

        {props.button && (
          <DialogActions>
            <Button autoFocus type="submit">
              {props.button}
            </Button>
          </DialogActions>
        )}
      </BootstrapDialog>
    </>
  );
}
